var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.cssClasses,
    _vm.isMenuCollapse ? 'menu-collapse' : 'menu-expand',
    { 'on-mobile-device': _vm.isMobileDevice, 'on-ipad': _vm.isIPad },
  ],attrs:{"id":"app","is-large":_vm.screen.isLarge,"is-medium":_vm.screen.isMedium,"is-small":_vm.screen.isSmall,"browse-name":_vm.browserName}},[(_vm.isPageLoading)?_c('div',{staticClass:"loading-page"},[_c('b-spinner',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPageLoading),expression:"isPageLoading"}],staticClass:"pre-loader",staticStyle:{"width":"5rem","height":"5rem"},attrs:{"variant":"navy","label":"Loading..."}})],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }